import { spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";
import { StyleSheet } from "react-native";

import { Box, TextLink } from "../../../../../../mads";
import { useViewjobOneGraphModel } from "../../../../context/ViewJobDataContext";

interface RelatedLinkProps {
  link: component.relatedlinks.RelatedLinksModel;
}

const RelatedLink: React.FC<RelatedLinkProps> = ({ link }) => {
  // TODO: Restore click logging to /rpc/log with params { a: 'vjsqc', href, vjtk: mobtk }
  // to keep parity with homepage-frontend's postRelatedLinksClick. Requires adding a signal
  // logging functionality
  return (
    <Box sx={relatedLinkStyles.container}>
      <TextLink targetUrl={link.href} level={2} variant="strong">
        {link.linkText}
      </TextLink>
    </Box>
  );
};

export const RelatedLinks: React.FC = () => {
  const relatedLinks = useViewjobOneGraphModel()?.relatedLinks;

  if (!relatedLinks || relatedLinks.length === 0) {
    return null;
  }

  return (
    <Box sx={styles.container} id="relatedLinks">
      {relatedLinks.map((link) => (
        <RelatedLink key={link.href} link={link} />
      ))}
    </Box>
  );
};

const relatedLinkStyles = StyleSheet.create({
  container: {
    marginBottom: spacing.s3,
  },
});

const styles = StyleSheet.create({
  container: {
    marginTop: spacing.s2,
  },
});

export default RelatedLinks;
